import { findListItem, getAuthDetails } from 'globalutils/fmUtils';

export const getConfig = (basePath, file) => {
  try {
    const config = require(`${basePath}/${file}`).default;
    return config;
  } catch (error) {
    return null;
  }
};

export const checkRole = (config) => {
  const auth = getAuthDetails();
  return findListItem(
    config.roles,
    auth.auth,
    [config.module, ...(config.dependency || '')],
    auth.enterpriseFeatureDto
  );
};

export const hasSubscription = (config) => {
  const auth = getAuthDetails();
  return (
    !!auth.subscriptions?.[config.subscriptions] ||
    !!auth.enterpriseFeatureDto?.[config.module] ||
    (auth.subscriptions?.[config.subscriptions] === undefined &&
      auth.enterpriseFeatureDto?.[config.module] === undefined)
  );
};

export const authValidator = (config) => {
  return {
    hasRolePermission: checkRole(config),
    isTierEnabled: hasSubscription(config)
  };
};
